import * as dateHelper from '../../utils/date.js'

const state = {
  fatalError: false,
  wizardStep: 1,
  wizardLabels: [
    'Start',
    'Transfers',
    'Build',
    'Rooming',
    'Passengers',
    'Summary',
    'Payment',
    'Thankyou'
  ],
  wizardComponents: [
    'app-start',
    'app-transfers',
    'app-day-by-day',
    'app-rooming',
    'app-passengers',
    'app-summary',
    'app-payment',
    'app-thankyou'
  ],
  errorComponent: 'app-error'
}

const getters = {
  wizardStepIndex(state) {
    return state.wizardStep - 1
  },
  wizardLabel(state, getters) {
    return state.wizardLabels[getters.wizardStepIndex]
  },
  wizardComponent(state, getters) {
    if (state.fatalError) {
      return state.errorComponent
    } else {
      return state.wizardComponents[getters.wizardStepIndex]
    }
  },
  wizardProgress(state) {
    return Math.min(
      Math.round((100 / state.wizardLabels.length) * state.wizardStep) + 5,
      100
    )
  },
  canNext(state) {
    return state.wizardStep <= state.wizardLabels.length
  },
  canPrev(state) {
    return state.wizardStep > 1 && state.wizardStep < 7
  }
}

const mutations = {
  nextStep(state) {
    state.wizardStep++
  },
  prevStep(state) {
    state.wizardStep--
  },
  setFatalError(state) {
    state.fatalError = true
  }
}

const actions = {
  nextStep({ commit, dispatch, state, rootState }) {
    if (state.wizardStep === 1) {
      // moving from first step load county data
      dispatch('initialiseCountyData', {
        countyId: rootState.start.selectedCounty.countyId,
        countyName: rootState.start.selectedCounty.name,
        fromDate: rootState.start.fromDate,
        toDate: dateHelper.addDays(
          rootState.start.fromDate,
          rootState.start.noOfNights
        )
      })
    }

    commit('nextStep')
  },
  prevStep({ commit }) {
    commit('prevStep')
  },
  setFatalError({ commit, rootState }, payload) {
    commit('setFatalError')

    // we expect the payload to be an axios error object
    if (payload) {
      // Error 😨
      if (payload.response) {
        /* The request was made and the server responded with a
         * status code that falls out of the range of 2xx */
        console.log(payload.response.data)
        console.log(payload.response.status)
        console.log(payload.response.headers)
      } else if (payload.request) {
        /* The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser */
        console.log(payload.request)
      } else {
        // Something happened in setting up the request and triggered an Error
        console.log('Error', payload.message)
      }
    }

    // log the day-by-day data for debugging purposes
    if (rootState.dayByDay.days) {
      console.log('Day-by-day Data', rootState.dayByDay.days)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
